import { createSelector } from "../../utils/selectors.js";
export const selectorChartSeriesState = state => state.series;
export const selectorChartSeriesProcessed = createSelector([selectorChartSeriesState], seriesState => seriesState.processedSeries);
export const selectorChartSeriesConfig = createSelector([selectorChartSeriesState], seriesState => seriesState.seriesConfig);